import React, { useState, useEffect } from 'react';
import { Input, Select } from 'antd'
import moment from 'moment';
import tasksService from './TasksService';

export const columns = [
    {
        title: 'Task Collection',
        dataIndex: 'taskCollection',
        key: 'taskCollection',
        shouldUseAsfilter: true,
        filterComponent: ({ addonBefore, value, onChange, fetchAllEntities }) => {

            const [collections, setCollections] = useState([]);
            const getCollections = async () => {
                const taskCollections = await tasksService.getTasksCollection();
                fetchAllEntities({ taskCollection: taskCollections?.[0] })
                onChange(taskCollections?.[0])
                setCollections(taskCollections)
            }

            useEffect(() => {
                getCollections();
            }, [])


            return (
                <div className={"task-collection-filter"}>
                    <p>{addonBefore}</p>
                    <Select value={value} onChange={onChange}>
                        {collections.map((collection) => <Select.Option value={collection}>{collection}</Select.Option>)}
                    </Select>
                </div>
            )
        },
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        shouldUseAsfilter: true,
        sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    {
        title: 'Account Id',
        dataIndex: 'accountId',
        key: 'accountId',
        shouldUseAsfilter: true,
        sorter: (a, b) => a?.accountId?.localeCompare(b?.accountId),
    },
    {
        title: 'Created At',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: (a, b) => a?.createdAt?.localeCompare(b?.createdAt),
        render: (d) => { return moment(d).format('M/D/YYYY @ H:M:SS A') },
    },
    {
        title: 'Updated',
        dataIndex: 'updated',
        key: 'updated',
        sorter: (a, b) => a?.updated?.localeCompare(b?.updated),
        render: (d) => { return moment(d).format('M/D/YYYY @ H:M:SS A') },
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        shouldUseAsfilter: true,
        sorter: (a, b) => a?.status?.localeCompare(b?.status),
        render: (d) => { return moment(d).format('M/D/YYYY @ H:M:SS A') },
    },
    {
        title: 'Error',
        dataIndex: 'error',
        key: 'error',
        sorter: (a, b) => a?.error?.localeCompare(b?.error),
    }
];

export const formSchema = [
    {
        props: {
            name: "taskCollection",
            label: "Task Collection",
            componentProps: {
                disabled: true
            }
        },
        component: ({ value, onChange }) => <Input value={value} disabled={true} />,
    },
    {
        props: {
            name: "name",
            label: "Name"
        },
        component: Input,
    }
]
